import type { ReviewSlideType } from '#base/core/types/ReviewSlideType';

const reviews: ReviewSlideType[] = [
	{
		rating: 10,
		reviewerName: 'Sharon',
		text: 'Sport inmiddels een jaar 2x in de week bij fysio hier. Ik vind het heel fijn dat ik zelf de dagen in kan plannen wanneer ik ga. De begeleiding is super, elke les kan je in je eigen tempo trainen en wordt je gemotiveerd om alles uit jezelf te halen.',
		age: 44,
	},
	{
		rating: 10,
		reviewerName: 'Kretin',
		text: 'Elke training is uitdagend en gevarieerd.',
		age: 26,
	},
	{
		rating: 10,
		reviewerName: 'Daniëlle',
		text: 'Een hele fijne sportschool met zeer persoonlijke begeleiding van Sjoerd en Lisanne. De lessen zijn met een maximale groepsgrootte van 6 pers en dat is heel prettig sporten! Echt een aanrader !!',
		age: 54,
	},
	{
		rating: 10,
		reviewerName: 'Irana',
		text: 'Mijn recensie over jullie is 1 en al positief. Ik kan het iedereen aanraden, en kom bij twijfel gewoon een keer meedoen. Ik ben in iedergeval blij dat ik die stap heb genomen. En ik voel me gewoon een stuk beter, fitter. En ondanks ik nu nog aan het sporten ben om mijn lichaam weer sterker te maken na mijn ziekte. Denk ik dat ik een blijvertje ben.',
		age: 48,
	},
];

export default reviews;
